import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Header.css';
import logo from '../../../src/components/Logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const menuRef = useRef(null);
  const hamburgerRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavClick = (path) => {
    setIsMenuOpen(false);
    navigate(path);
    window.scrollTo(0, 0);
  };

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && isMenuOpen) {
        setIsMenuOpen(false);
        hamburgerRef.current?.focus();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isMenuOpen]);

  // Focus management for menu
  useEffect(() => {
    if (isMenuOpen && menuRef.current) {
      const firstButton = menuRef.current.querySelector('button');
      firstButton?.focus();
    }
  }, [isMenuOpen]);

  return (
    <header className="header" role="banner">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <button 
              onClick={() => handleNavClick('/')}
              aria-label="Auto Cross - חזור לעמוד הבית"
              className="logo-button"
            >
              <img src={logo} alt="לוגו Auto Cross - יבוא רכב ומוניות" />
            </button>
          </div>

          <button
            ref={hamburgerRef}
            className={`hamburger-menu ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label={isMenuOpen ? 'סגור תפריט ניווט' : 'פתח תפריט ניווט'}
            aria-expanded={isMenuOpen}
            aria-controls="main-navigation"
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </button>

          <nav 
            ref={menuRef}
            className={`main-nav ${isMenuOpen ? 'active' : ''}`}
            role="navigation"
            aria-label="ניווט ראשי"
            id="main-navigation"
          >
            <ul role="menubar">
              <li role="none">
                <button 
                  onClick={() => handleNavClick('/')} 
                  className={location.pathname === '/' ? 'active' : ''}
                  role="menuitem"
                  aria-current={location.pathname === '/' ? 'page' : undefined}
                >
                  בית
                </button>
              </li>
              <li role="none">
                <button 
                  onClick={() => handleNavClick('/taxis')} 
                  className={`taxi-button${location.pathname === '/taxis' ? ' active' : ''}`}
                  role="menuitem"
                  aria-current={location.pathname === '/taxis' ? 'page' : undefined}
                >
                  <img src="/taxi_hat.png" alt="" className="taxi-hat-img" aria-hidden="true" />
                  <span>מוניות למכירה</span>
                </button>
              </li>
              <li role="none">
                <button 
                  onClick={() => handleNavClick('/financing')} 
                  className={location.pathname === '/financing' ? 'active' : ''}
                  role="menuitem"
                  aria-current={location.pathname === '/financing' ? 'page' : undefined}
                >
                  מימון
                </button>
              </li>
              <li role="none">
                <button 
                  onClick={() => handleNavClick('/service')} 
                  className={location.pathname === '/service' ? 'active' : ''}
                  role="menuitem"
                  aria-current={location.pathname === '/service' ? 'page' : undefined}
                >
                  שירות ואחריות
                </button>
              </li>
              <li role="none">
                <button 
                  onClick={() => handleNavClick('/about')} 
                  className={location.pathname === '/about' ? 'active' : ''}
                  role="menuitem"
                  aria-current={location.pathname === '/about' ? 'page' : undefined}
                >
                  אודותינו
                </button>
              </li>
              <li role="none">
                <button 
                  onClick={() => handleNavClick('/contact')} 
                  className={location.pathname === '/contact' ? 'active' : ''}
                  role="menuitem"
                  aria-current={location.pathname === '/contact' ? 'page' : undefined}
                >
                  צור קשר
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
